import React from "react";
import GenericMaterialCategory from "./materials/GenericMaterialCategory";

export default function RFQ({ selectedMaterial, dealers, dealersLoading, clientId }) {
  return (
    <div className="flex-1 bg-gray-200 dark:bg-gray-800 overflow-auto">
      {dealersLoading ? (
        <div className="flex items-center justify-center h-full text-gray-500 dark:text-gray-400">
          Loading dealers...
        </div>
      ) : selectedMaterial ? (
        <GenericMaterialCategory categoryName={selectedMaterial} dealers={dealers} clientId={clientId} />
      ) : (
        <div className="flex items-center justify-center h-full text-gray-500 dark:text-gray-400">
          Select a material to get started
        </div>
      )}
    </div>
  );
}
